import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react';
import { Control, Controller, FieldError } from 'react-hook-form';
import { FormularioVitrine } from '../types';

type CampoNumerico = 'size' | 'min_products' | 'min_cooccurrence' | 'limit';

interface Props {
  control: Control<FormularioVitrine>;
  name: CampoNumerico;
  id?: string;
  label: string;
  min: number;
  max: number;
  ajuda?: string;
  error?: FieldError;
  /** Campos revalidados junto quando este muda (ex.: limit depende de size). */
  dependentes?: CampoNumerico[];
}

/** NumberInput do Chakra ligado ao react-hook-form, guardando número (ou '' se vazio). */
const CampoNumero: React.FC<Props> = ({
  control,
  name,
  id = name,
  label,
  min,
  max,
  ajuda,
  error,
  dependentes,
}) => (
  <FormControl isInvalid={!!error}>
    <FormLabel htmlFor={id}>{label}</FormLabel>
    <Controller
      name={name}
      control={control}
      rules={{ deps: dependentes }}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <NumberInput
          id={id}
          min={min}
          max={max}
          value={value ?? ''}
          onChange={(_texto, numero) =>
            onChange(Number.isNaN(numero) ? '' : numero)
          }
          onBlur={onBlur}
          focusBorderColor="brand.500"
          bg="white"
        >
          <NumberInputField ref={ref} />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
      )}
    />
    {error ? (
      <FormErrorMessage>{error.message}</FormErrorMessage>
    ) : (
      <FormHelperText>
        {ajuda ? `${ajuda} ` : ''}
        {`(de ${min} a ${max})`}
      </FormHelperText>
    )}
  </FormControl>
);

export default CampoNumero;
